var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2 17.1q0-.797.398-1.465a2.7 2.7 0 0 1 1.057-1.02q1.408-.726 2.863-1.09 1.455-.362 2.955-.363 1.5 0 2.954.364 1.455.363 2.864 1.09.66.351 1.057 1.02.398.667.398 1.464v.75q0 .774-.535 1.324-.534.55-1.284.551H3.818q-.75 0-1.284-.55A1.83 1.83 0 0 1 2 17.85zm18.182 2.625h-2.318q.249-.422.375-.902.125-.48.125-.973v-.937a3.86 3.86 0 0 0-.557-1.981q-.557-.95-1.58-1.629a11.2 11.2 0 0 1 4.091 1.313q.819.468 1.25 1.043.432.573.432 1.254v.937q0 .774-.534 1.324t-1.284.551m-10.91-7.5q-1.5 0-2.567-1.102-1.07-1.101-1.069-2.648 0-1.547 1.069-2.648t2.568-1.102 2.568 1.102 1.068 2.648-1.068 2.648-2.568 1.102m9.092-3.75q0 1.547-1.069 2.648t-2.568 1.102q-.25 0-.636-.059a5 5 0 0 1-.636-.129 5.62 5.62 0 0 0 0-7.125q.318-.117.636-.152a6 6 0 0 1 .636-.035q1.5 0 2.569 1.102 1.068 1.101 1.068 2.648M3.818 17.85h10.91v-.75a.9.9 0 0 0-.455-.797 11.6 11.6 0 0 0-2.477-.95 10.24 10.24 0 0 0-5.046 0q-1.25.317-2.477.95a.9.9 0 0 0-.33.328.9.9 0 0 0-.125.469zm5.455-7.5q.75 0 1.284-.55.534-.552.534-1.325 0-.774-.534-1.324A1.73 1.73 0 0 0 9.273 6.6q-.75 0-1.284.55a1.83 1.83 0 0 0-.534 1.325q0 .774.534 1.324t1.284.551"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.eeaaf2a49783d7721a1507b9cfd8f280.svg";
export { ForwardRef as ReactComponent };